import React, { Component } from "react";
import Header from "./Header";
import Footer from "./Footer";
import HeaderIntroLoans from "./HeaderIntroLoans";
export class EducationLoan extends Component {
  render() {
    return (
      <div>
        <Header />
        <div>
          <HeaderIntroLoans />
        </div>

        <section id="about">
          <div class="container" data-aos="fade-up">
            <header class="section-header">
              <h3>EDUCATION LOANS</h3>
              <p>
                You may have studied hard and excelled in your exams or just
                planned the next move in your career. Whatever be your reason to
                study, your research should end at finding the right institute.
                Let finance be the last thing to worry about. We at ClipTax,
                understand your career aspirations and offer Education Loan to
                help you pay your tuition fees and living cost when you are
                looking to take the next steps in your education, both in India
                and abroad.
                <br />
                With quick approval rates, minimal documentation & competitive
                interest rates, we are levelling the playing field so that you
                can fulfil your potential. The highest quality of education
                should be available for all regardless of someone’s financial
                background. That’s precisely the reason why we have made the
                availability of Student Loans as accessible as possible. Whether
                you are a student or a parent seeking to provide your children
                with the very best, we are here to support you.
              </p>
            </header>
          </div>
        </section>

        <section id="why-us">
          <div class="container" data-aos="fade-up">
            <header class="section-header">
              <h3>HOW IT WORKS?</h3>
              {/* <p>
                Any business offering sale of goods with annual turn over of 40
                lacs or service with annual turn over of 20 lacs would require
                the registration for GST and have a valid GST Number.
              </p> */}
            </header>

            <div class="row row-eq-height justify-content-center">
              <div class="col-lg-4 mb-4">
                <div class="card" data-aos="zoom-in" data-aos-delay="100">
                  <i class="fa fa-diamond"></i>
                  <div class="card-body">
                    <h5 class="card-title">Step 1:</h5>
                    <p class="card-text">
                      Quick Register : Fill up a Simple Form
                    </p>
                    <a href="#" class="readmore">
                      Read more{" "}
                    </a>
                  </div>
                </div>
              </div>

              <div class="col-lg-4 mb-4">
                <div class="card" data-aos="zoom-in" data-aos-delay="200">
                  <i class="fa fa-language"></i>
                  <div class="card-body">
                    <h5 class="card-title">Step 2:</h5>
                    <p class="card-text">
                      Select From Multiple Offers : List of Offers from Multiple
                      Banks Banks
                    </p>
                    <a href="#" class="readmore">
                      Read more{" "}
                    </a>
                  </div>
                </div>
              </div>

              <div class="col-lg-4 mb-4">
                <div class="card" data-aos="zoom-in" data-aos-delay="300">
                  <i class="fa fa-object-group"></i>
                  <div class="card-body">
                    <h5 class="card-title">Step 3:</h5>
                    <p class="card-text">
                      Apply : Quick Application in less than 15 mins{" "}
                    </p>
                    <a href="#" class="readmore">
                      Read more{" "}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section id="services" class="section-bg">
          <div class="container" data-aos="fade-up">
            <header class="section-header">
              <h3>BENEFITS AND FEATURES OF EDUCATION LOANS</h3>
              <br />
              {/* <p>
                At ClipTax, we ensure a smooth entry for you in market, while
                guiding and assisting you through the complex procedures of
                Business Registration. Our focus is on simplifying toilsome
                procedures for incorporation of your business so that you can
                purely concentrate on your business intent. You dream, Cliptax
                executes!
              </p> */}
            </header>

            <div class="row justify-content-center">
              <div
                class="col-md-6 col-lg-5"
                data-aos="zoom-in"
                data-aos-delay="100"
              >
                <div class="box">
                  <div class="icon">
                    <i
                      class="ion-ios-analytics-outline"
                      style={{ color: "#ff689b" }}
                    ></i>
                  </div>
                  <h4 class="title">
                    <a href="">Low Interest Rate</a>
                  </h4>
                  <p class="description">
                    Education Loan comes under priority sector lending and
                    Reserve bank of India has made it mandatory to lend 40 % to
                    priority sector. This has led to availability of education
                    loans at very low and economical price with very low
                    interest rate.
                  </p>
                </div>
              </div>
              <div
                class="col-md-6 col-lg-5"
                data-aos="zoom-in"
                data-aos-delay="200"
              >
                <div class="box">
                  <div class="icon">
                    <i
                      class="ion-ios-bookmarks-outline"
                      style={{ color: "#e9bf06" }}
                    ></i>
                  </div>
                  <h4 class="title">
                    <a href="">Tax Benefit</a>
                  </h4>
                  <p class="description">
                    There is a provision made by the Government of India under
                    Sec 80E claiming that an individual standing as a guarantor
                    for the loan can avail the tax benefit by reducing his
                    taxable income by the amount of interest accrued and paid on
                    the loan in a financial year. Moreover there is no upper cap
                    on the exemption.
                  </p>
                </div>
              </div>

              <div
                class="col-md-6 col-lg-5"
                data-aos="zoom-in"
                data-aos-delay="100"
              >
                <div class="box">
                  <div class="icon">
                    <i
                      class="ion-ios-paper-outline"
                      style={{ color: "#3fcdc7" }}
                    ></i>
                  </div>
                  <h4 class="title">
                    <a href="">Flexible Payment Terms</a>
                  </h4>
                  <p class="description">
                    Many of the financial institutions have fully or partially
                    waved the payment of equated monthly instalments at the time
                    of the study. Generally, you get a year after completion of
                    studies to find a job and then you can start paying the
                    monthly instalments. Thus it is very convenient for
                    students.
                  </p>
                </div>
              </div>
              <div
                class="col-md-6 col-lg-5"
                data-aos="zoom-in"
                data-aos-delay="200"
              >
                <div class="box">
                  <div class="icon">
                    <i
                      class="ion-ios-speedometer-outline"
                      style={{ color: "#41cf2e" }}
                    ></i>
                  </div>
                  <h4 class="title">
                    <a href="">
                      Availability of the loan even if the earning of guarantor
                      is low
                    </a>
                  </h4>
                  <p class="description">
                    Education loan is one such loan which is made available for
                    you keeping in mind your future earning potential and not
                    the potential of your guarantor. Thus the earning of the
                    guarantor does not matter here. You can easily acquire the
                    loan even if your parents are not earning or are retired.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section id="services" class="section-bg">
          <div class="container" data-aos="fade-up">
            <header class="section-header">
              <h3>DOCUMENTS REQUIRED FOR EDUCATION LOAN</h3>
              <br />
              {/* <p>
                At ClipTax, we ensure a smooth entry for you in market, while
                guiding and assisting you through the complex procedures of
                Business Registration. Our focus is on simplifying toilsome
                procedures for incorporation of your business so that you can
                purely concentrate on your business intent. You dream, Cliptax
                executes!
              </p> */}
            </header>

            <div class="row justify-content-center">
              <div
                class="col-md-6 col-lg-5"
                data-aos="zoom-in"
                data-aos-delay="100"
              >
                <div class="box">
                  <div class="icon">
                    <i
                      class="ion-ios-analytics-outline"
                      style={{ color: "#ff689b" }}
                    ></i>
                  </div>
                  <h4 class="title">
                    <a href="">Photo Identity Proof</a>
                  </h4>
                  <p class="description">
                    Copy of photo identity proof of both the student and parent.
                    Can also submit a copy of Voter ID/ Passport/ Driving
                    License/ Aadhar Card
                  </p>
                </div>
              </div>
              <div
                class="col-md-6 col-lg-5"
                data-aos="zoom-in"
                data-aos-delay="200"
              >
                <div class="box">
                  <div class="icon">
                    <i
                      class="ion-ios-bookmarks-outline"
                      style={{ color: "#e9bf06" }}
                    ></i>
                  </div>
                  <h4 class="title">
                    <a href="">Mark Sheets and Certificates</a>
                  </h4>
                  <p class="description">
                   Attendance copies of Mark Sheets and Certificates (from 10th Standards)
                  </p>
                </div>
              </div>

              <div
                class="col-md-6 col-lg-5"
                data-aos="zoom-in"
                data-aos-delay="100"
              >
                <div class="box">
                  <div class="icon">
                    <i
                      class="ion-ios-paper-outline"
                      style={{ color: "#3fcdc7" }}
                    ></i>
                  </div>
                  <h4 class="title">
                    <a href="">Document for Studying Abroad</a>
                  </h4>
                  <p class="description">
                    Employment Contract, Entry Permit, Admission Letter and I-20 for for foreign Institution 
                  </p>
                </div>
              </div>
              <div
                class="col-md-6 col-lg-5"
                data-aos="zoom-in"
                data-aos-delay="200"
              >
                <div class="box">
                  <div class="icon">
                    <i
                      class="ion-ios-speedometer-outline"
                      style={{ color: "#41cf2e" }}
                    ></i>
                  </div>
                  <h4 class="title">
                    <a href="">Admission Letter</a>
                  </h4>
                  <p class="description">
                    An issued by the admitting School/ College/ Institute
                  </p>
                </div>
              </div>

              <div
                class="col-md-6 col-lg-5"
                data-aos="zoom-in"
                data-aos-delay="200"
              >
                <div class="box">
                  <div class="icon">
                    <i
                      class="ion-ios-speedometer-outline"
                      style={{ color: "#41cf2e" }}
                    ></i>
                  </div>
                  <h4 class="title">
                    <a href="">Income Proof</a>
                  </h4>
                  <p class="description">
                    Bank statements for the past six months
                  </p>
                </div>
              </div>
              <div
                class="col-md-6 col-lg-5"
                data-aos="zoom-in"
                data-aos-delay="100"
              >
                <div class="box">
                  <div class="icon">
                    <i
                      class="ion-ios-paper-outline"
                      style={{ color: "#3fcdc7" }}
                    ></i>
                  </div>
                  <h4 class="title">
                    <a href="">Employment Details (If Employed)</a>
                  </h4>
                  <p class="description">
                    Resignation Letter, Acceptance of Resignation Letter or Sanction Letter for study leave 
                  </p>
                </div>
              </div>

              <div
                class="col-md-6 col-lg-5"
                data-aos="zoom-in"
                data-aos-delay="200"
              >
                <div class="box">
                  <div class="icon">
                    <i
                      class="ion-ios-speedometer-outline"
                      style={{ color: "#41cf2e" }}
                    ></i>
                  </div>
                  <h4 class="title">
                    <a href="">Salary Slips</a>
                  </h4>
                  <p class="description">
                    For the last three months and ITR of Parents/Guarantor
                  </p>
                </div>
              </div>
              <div
                class="col-md-6 col-lg-5"
                data-aos="zoom-in"
                data-aos-delay="100"
              >
                <div class="box">
                  <div class="icon">
                    <i
                      class="ion-ios-paper-outline"
                      style={{ color: "#3fcdc7" }}
                    ></i>
                  </div>
                  <h4 class="title">
                    <a href="">Other Documents</a>
                  </h4>
                  <p class="description">
                    All essential documents issued by the admitting School/ College/ Institute including prospectus, breakup of fees etc. 
                  </p>
                </div>
              </div>
              <div
                class="col-md-6 col-lg-5"
                data-aos="zoom-in"
                data-aos-delay="100"
              >
                <div class="box">
                  <div class="icon">
                    <i
                      class="ion-ios-paper-outline"
                      style={{ color: "#3fcdc7" }}
                    ></i>
                  </div>
                  <h4 class="title">
                    <a href="">Property Documents</a>
                  </h4>
                  <p class="description">
                    If there is an immovable property offered as security
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <Footer />
      </div>
    );
  }
}

export default EducationLoan;
